// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2899":"478a1563","9645":"6c2d633b","9679":"118d3274"}[chunkId] + ".chunk.css";
};